export default function guest({ next }) {
  const authToken = sessionStorage.getItem('authtoken');

  if (authToken) {
      return next({
          name: 'home'
      })
  } 
  
  return next()
}